import React from 'react';

interface ReportPageProps {
    children: React.ReactNode;
}

export function ReportPage({ children }: ReportPageProps) {
    return <div className="p-4 pt-2">{children}</div>;
}